export const ADDRESS_CONSTANTS = {
  UNIT_TYPES: [
    { label: '-', value: null },
    { label: 'Unit', value: 'Unit' },
    { label: 'Suite', value: 'Ste' },
    { label: 'Apartment', value: 'Apt' },
    { label: 'Room', value: 'Room' },
    { label: 'Slip', value: 'Slip' },
    { label: 'Lot', value: 'Lot' },
    { label: 'Floor', value: 'FL' },
    { label: '#', value: '#' }
  ],

  STRUCTURE_TYPES: [
    'Building',
    'Pier',
    'Wing',
    'Trailer'
  ]
}